/* eslint-disable */
import React, { useEffect } from "react";
import { getNeighboursServices } from "../../../../actions/appExpandedActions/communities";
import { connect } from "react-redux";
import DataTable from "../../DataTable/DataTable";

const AssistantCommunities = ({ getNeighboursServices, communityServices, period }) => {
  useEffect(() => {
    getNeighboursServices({ page: 1, limit: 20 });
  }, []);

  // Handle period changes - support new PeriodSelector format
  useEffect(() => {
    const payload = { page: 1, limit: 20 };
    
    // For "All time" or no dates, send empty strings
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      // For specific periods, send the actual dates
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighboursServices(payload);
  }, [period]);

  const handleLoadMore = (page) => {
    const payload = { page, limit: 20 };
    
    if (period?.type === "all" || (!period?.startDate && !period?.endDate)) {
      payload.startDate = "";
      payload.endDate = "";
    } else if (period?.startDate && period?.endDate) {
      payload.startDate = period.startDate;
      payload.endDate = period.endDate;
    }
    
    getNeighboursServices(payload);
  };

  return (
    <DataTable
      preset="assistantCommunities"
      data={{
        docs: communityServices?.docs || [],
        totalPages: communityServices?.totalPages || 0
      }}
      onLoadMore={handleLoadMore}
      loading={false}
    />
  );
};

const mapStateToProps = (state) => ({
  communityServices: state.appCommunities.communityServices,
});

const mapDispatchToProps = (dispatch) => ({
  getNeighboursServices: (payload) => dispatch(getNeighboursServices(payload)),
});

export default connect(mapStateToProps, mapDispatchToProps)(AssistantCommunities);
